import React from 'react';
import { Td, Tr } from '@chakra-ui/react';
import PdfFirebaseUrlParser from '../../utils/pdf-firebase-url-parser';
import { PlayIcon } from '../ui-components/PlayIcon';

const VIDEO_MEDIA_TYPES = ['youtube', 'video'];

const ItemAnchor = ({ onClick, children }) => {
  return (
    <a onClick={onClick} style={{ cursor: 'pointer' }}>
      {children}
    </a>
  );
};

const TechLibraryItemRow = ({ item, onOpen }) => {
  const mediaType = item.media_type.toLowerCase();
  const mediaUrl = mediaType === 'youtube' ? item.dataUrl : PdfFirebaseUrlParser.getUrl(item.dataUrl);
  const isVideo = VIDEO_MEDIA_TYPES.includes(mediaType);

  const openItem = () => {
    onOpen({ title: item.displaytextheader, pdfLink: mediaUrl, mediaType });
  };

  return (
    <Tr sx={{ '&:first-of-type': { pt: 5 } }}>
      <Td className="text-sm uppercase w-40 min-w-24">
        {isVideo && <PlayIcon className="mr-1 text-blue" />}
        <ItemAnchor onClick={openItem}>{item.calledby}</ItemAnchor>
      </Td>
      <Td className="text-sm w-40 min-w-24">
        <ItemAnchor onClick={openItem}>{item.returntotext2}</ItemAnchor>
      </Td>
      <Td className="text-sm min-w-36">
        <ItemAnchor onClick={openItem}>{item.displaytextheader}</ItemAnchor>
      </Td>
    </Tr>
  );
};

export default TechLibraryItemRow;
